var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"text-center pt15"},[_c('img',{attrs:{"src":"resources/images/logoHolding.png","width":"200"}})]),_c('h1',{staticClass:"text-center pt10"},[_c('strong',[_vm._v("Panel de Administración")])])])])])])])
}]

export { render, staticRenderFns }